import { useLanguage } from "../context/LanguageContext";
import translations from "../data/translations";

type TranslationKey = keyof typeof translations.en | keyof typeof translations.zh | keyof typeof translations.ja;

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = (key: TranslationKey) => {
    const translation = translations[language][key];
    return translation || key;
  };

  return { t };
};
